var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "small-container", attrs: { id: "footer" } },
      [_c("div", { staticClass: "footer" }, [_c("p")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }